import { createAction } from "@reduxjs/toolkit";
import {
  acceptInviteActionTypes,
  banParticipantActionTypes,
  changeParticipantRoleActionTypes,
  createLivestreamActionTypes,
  deleteAllParticipantMessagesActionTypes,
  deleteLivestreamGoalActionTypes,
  deleteMessageActionTypes,
  endLivestreamActionTypes,
  endSpinTheBottleActionTypes,
  getInviteListActionTypes,
  getLivestreamDetailsActionTypes,
  getLivestreamsActionTypes,
  getLivestreamsPortionActionTypes,
  getMessagesActionTypes,
  getNewMessageActionTypes,
  getNewTipActionTypes,
  getParticipantsActionTypes,
  getParticipantsUpdateActionTypes,
  getTopTippersActionTypes,
  getUpdatedLivestreamDetailsActionTypes,
  handleBanParticipantActionTypes,
  handleChangeCoStreamerRoleToViewerActionTypes,
  handleCoStreamerStartsStreamActionTypes,
  handleDeleteAllParticipantMessagesActionTypes,
  handleDeleteMessageActionTypes,
  handleHostAcceptedRequestToCoStreamingActionTypes,
  handleInviteFromStreamerToViewerActionsTypes,
  handleMuteParticipantActionTypes,
  inviteParticipantActionTypes,
  joinLivestreamActionTypes,
  leaveLivestreamActionTypes,
  livestreamEndedActionTypes,
  makeButtonInvitableActionType,
  makeCoStreamerAViewerActionTypes,
  muteParticipantActionTypes,
  rejectAllActionTypes,
  rejectInviteActionTypes,
  reportStreamActionTypes,
  requestInviteToCoStreamingActionTypes,
  resetActiveStreamActionType,
  resetLivestreamsActionType,
  resetRoleWasChangedFlagActionType,
  sendMessageActionTypes,
  setTipsListActionType,
  spinTheBottleActionTypes,
  startSpinTheBottleActionTypes,
  unmuteMeActionType,
  updateLivestreamActionTypes,
  updateLivestreamGoalActionTypes,
  updateLivestreamPreviewImageActionTypes,
} from "./actionTypes";

// createLivestream
export const createLivestream = createAction(
  createLivestreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const createLivestreamSuccess = createAction(
  createLivestreamActionTypes.success,
  (payload) => ({ payload }),
);

export const createLivestreamFailure = createAction(
  createLivestreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const createLivestreamReset = createAction(
  createLivestreamActionTypes.reset,
  (payload) => ({
    payload,
  }),
);
//

// updateLivestream
export const updateLivestream = createAction(
  updateLivestreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const updateLivestreamSuccess = createAction(
  updateLivestreamActionTypes.success,
  (payload) => ({ payload }),
);

export const updateLivestreamFailure = createAction(
  updateLivestreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// endLivestream
export const endLivestream = createAction(
  endLivestreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const endLivestreamSuccess = createAction(
  endLivestreamActionTypes.success,
  (payload) => ({ payload }),
);

export const endLivestreamFailure = createAction(
  endLivestreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getLivestreams
export const getLivestreams = createAction(
  getLivestreamsActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getLivestreamsSuccess = createAction(
  getLivestreamsActionTypes.success,
  (payload) => ({ payload }),
);

export const getLivestreamsFailure = createAction(
  getLivestreamsActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getLivestreamsPortion
export const getLivestreamsPortion = createAction(
  getLivestreamsPortionActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getLivestreamsPortionSuccess = createAction(
  getLivestreamsPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getLivestreamsPortionFailure = createAction(
  getLivestreamsPortionActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// joinLivestreamActionTypes
export const joinLivestream = createAction(
  joinLivestreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const joinLivestreamSuccess = createAction(
  joinLivestreamActionTypes.success,
  (payload) => ({ payload }),
);

export const joinLivestreamFailure = createAction(
  joinLivestreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// leaveLivestreamActionTypes
export const leaveLivestream = createAction(
  leaveLivestreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const leaveLivestreamSuccess = createAction(
  leaveLivestreamActionTypes.success,
  (payload) => ({ payload }),
);

export const leaveLivestreamFailure = createAction(
  leaveLivestreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// resetLivestream
export const resetLivestreams = createAction(
  resetLivestreamsActionType,
  (error) => ({
    payload: error,
  }),
);

// sendMessageActionTypes
export const sendMessage = createAction(
  sendMessageActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const sendMessageSuccess = createAction(
  sendMessageActionTypes.success,
  (payload) => ({ payload }),
);

export const sendMessageFailure = createAction(
  sendMessageActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getMessagesActionTypes
export const getMessages = createAction(
  getMessagesActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getMessagesSuccess = createAction(
  getMessagesActionTypes.success,
  (payload) => ({ payload }),
);

export const getMessagesFailure = createAction(
  getMessagesActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getParticipantsActionTypes
export const getParticipants = createAction(
  getParticipantsActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getParticipantsSuccess = createAction(
  getParticipantsActionTypes.success,
  (payload) => ({ payload }),
);

export const getParticipantsFailure = createAction(
  getParticipantsActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getTopTippersActionTypes
export const getTopTippers = createAction(
  getTopTippersActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getTopTippersSuccess = createAction(
  getTopTippersActionTypes.success,
  (payload) => ({ payload }),
);

export const getTopTippersFailure = createAction(
  getTopTippersActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// changeParticipantRoleActionTypes
export const changeParticipantRole = createAction(
  changeParticipantRoleActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const changeParticipantRoleSuccess = createAction(
  changeParticipantRoleActionTypes.success,
  (payload) => ({ payload }),
);

export const changeParticipantRoleFailure = createAction(
  changeParticipantRoleActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// deleteMessageActionTypes
export const deleteMessage = createAction(
  deleteMessageActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const deleteMessageSuccess = createAction(
  deleteMessageActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteMessageFailure = createAction(
  deleteMessageActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// deleteAllParticipantMessages
export const deleteAllParticipantMessages = createAction(
  deleteAllParticipantMessagesActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const deleteAllParticipantMessagesSuccess = createAction(
  deleteAllParticipantMessagesActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteAllParticipantMessagesFailure = createAction(
  deleteAllParticipantMessagesActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// banParticipantActionTypes
export const banParticipant = createAction(
  banParticipantActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const banParticipantSuccess = createAction(
  banParticipantActionTypes.success,
  (payload) => ({ payload }),
);

export const banParticipantFailure = createAction(
  banParticipantActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// muteParticipantActionTypes
export const muteParticipant = createAction(
  muteParticipantActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const muteParticipantSuccess = createAction(
  muteParticipantActionTypes.success,
  (payload) => ({ payload }),
);

export const muteParticipantFailure = createAction(
  muteParticipantActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// reportStream
export const reportStream = createAction(
  reportStreamActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const reportStreamSuccess = createAction(
  reportStreamActionTypes.success,
  (payload) => ({ payload }),
);

export const reportStreamFailure = createAction(
  reportStreamActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// updateLivestreamPreview
export const updateLivestreamPreviewImage = createAction(
  updateLivestreamPreviewImageActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const updateLivestreamPreviewImageSuccess = createAction(
  updateLivestreamPreviewImageActionTypes.success,
  (payload) => ({ payload }),
);

export const updateLivestreamPreviewImageFailure = createAction(
  updateLivestreamPreviewImageActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// getInviteListActionTypes
export const getInviteList = createAction(
  getInviteListActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getInviteListSuccess = createAction(
  getInviteListActionTypes.success,
  (payload) => ({ payload }),
);

export const getInviteListFailure = createAction(
  getInviteListActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);
// inviteParticipantActionTypes
export const inviteParticipant = createAction(
  inviteParticipantActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const inviteParticipantSuccess = createAction(
  inviteParticipantActionTypes.success,
  (payload) => ({ payload }),
);

export const inviteParticipantFailure = createAction(
  inviteParticipantActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// acceptInviteActionTypes
export const acceptInvite = createAction(
  acceptInviteActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const acceptInviteSuccess = createAction(
  acceptInviteActionTypes.success,
  (payload) => ({ payload }),
);

export const acceptInviteFailure = createAction(
  acceptInviteActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// rejectInviteActionTypes
export const rejectInvite = createAction(
  rejectInviteActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const rejectInviteSuccess = createAction(
  rejectInviteActionTypes.success,
  (payload) => ({ payload }),
);

export const rejectInviteFailure = createAction(
  rejectInviteActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// rejectAllActionTypes
export const rejectAll = createAction(
  rejectAllActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const rejectAllSuccess = createAction(
  rejectAllActionTypes.success,
  (payload) => ({ payload }),
);

export const rejectAllFailure = createAction(
  rejectAllActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// requestInviteToCoStreamingActionTypes
export const requestInviteToCoStreaming = createAction(
  requestInviteToCoStreamingActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const requestInviteToCoStreamingSuccess = createAction(
  requestInviteToCoStreamingActionTypes.success,
  (payload) => ({ payload }),
);

export const requestInviteToCoStreamingFailure = createAction(
  requestInviteToCoStreamingActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// socket event actions
export const getNewMessageSuccess = createAction(
  getNewMessageActionTypes.success,
  (payload) => ({ payload }),
);

export const handleDeleteMessageSuccess = createAction(
  handleDeleteMessageActionTypes.success,
  (payload) => ({ payload }),
);

export const handleBanParticipantSuccess = createAction(
  handleBanParticipantActionTypes.success,
  (payload) => ({ payload }),
);
export const handleMuteParticipantSuccess = createAction(
  handleMuteParticipantActionTypes.success,
  (payload) => ({ payload }),
);
export const handleChangeCoStreamerRoleToViewerSuccess = createAction(
  handleChangeCoStreamerRoleToViewerActionTypes.success,
  (payload) => ({ payload }),
);
export const handleCoStreamerStartsStreamSuccess = createAction(
  handleCoStreamerStartsStreamActionTypes.success,
  (payload) => ({ payload }),
);

export const getNewTipSuccess = createAction(
  getNewTipActionTypes.success,
  (payload) => ({ payload }),
);
export const getLivestreamDetails = createAction(
  getLivestreamDetailsActionTypes.request,
  (payload) => ({ payload }),
);

export const getLivestreamDetailsSuccess = createAction(
  getLivestreamDetailsActionTypes.success,
  (payload) => ({ payload }),
);
export const getLivestreamDetailsFailure = createAction(
  getLivestreamDetailsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getUpdatedLivestreamDetailsSuccess = createAction(
  getUpdatedLivestreamDetailsActionTypes.success,
  (payload) => ({ payload }),
);

export const getParticipantsUpdateSuccess = createAction(
  getParticipantsUpdateActionTypes.success,
  (payload) => ({ payload }),
);

export const livestreamEndedSuccess = createAction(
  livestreamEndedActionTypes.success,
  (payload) => ({ payload }),
);
export const handleDeleteAllParticipantMessagesSuccess = createAction(
  handleDeleteAllParticipantMessagesActionTypes.success,
  (payload) => ({ payload }),
);

export const handleHostAcceptedRequestToCoStreamingSuccess = createAction(
  handleHostAcceptedRequestToCoStreamingActionTypes.success,
  (payload) => ({ payload }),
);

export const handleInviteFromStreamerToViewerSuccess = createAction(
  handleInviteFromStreamerToViewerActionsTypes.success,
  (payload) => ({ payload }),
);

export const resetRoleWasChangedFlag = createAction(
  resetRoleWasChangedFlagActionType,
  (payload) => ({ payload }),
);
export const resetActiveStream = createAction(
  resetActiveStreamActionType,
  (payload) => ({ payload }),
);
export const setTipsList = createAction(setTipsListActionType, (payload) => ({
  payload,
}));

export const unmuteMe = createAction(unmuteMeActionType, (payload) => ({
  payload,
}));

export const makeButtonInvitable = createAction(
  makeButtonInvitableActionType,
  (payload) => ({
    payload,
  }),
);

// updateLivestreamGoal
export const updateLivestreamGoal = createAction(
  updateLivestreamGoalActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const updateLivestreamGoalSuccess = createAction(
  updateLivestreamGoalActionTypes.success,
  (payload) => ({ payload }),
);

export const updateLivestreamGoalFailure = createAction(
  updateLivestreamGoalActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// deleteLivestreamGoal
export const deleteLivestreamGoal = createAction(
  deleteLivestreamGoalActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const deleteLivestreamGoalSuccess = createAction(
  deleteLivestreamGoalActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteLivestreamGoalFailure = createAction(
  deleteLivestreamGoalActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// startSpinTheBottle
export const startSpinTheBottle = createAction(
  startSpinTheBottleActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const startSpinTheBottleSuccess = createAction(
  startSpinTheBottleActionTypes.success,
  (payload) => ({ payload }),
);

export const startSpinTheBottleFailure = createAction(
  startSpinTheBottleActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// endSpinTheBottle
export const endSpinTheBottle = createAction(
  endSpinTheBottleActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const endSpinTheBottleSuccess = createAction(
  endSpinTheBottleActionTypes.success,
  (payload) => ({ payload }),
);

export const endSpinTheBottleFailure = createAction(
  endSpinTheBottleActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// makeSpinTheBottle
export const spinTheBottle = createAction(
  spinTheBottleActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const spinTheBottleSuccess = createAction(
  spinTheBottleActionTypes.success,
  (payload) => ({ payload }),
);

export const spinTheBottleFailure = createAction(
  spinTheBottleActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

// makeCoStreamerAViewerActionTypes
export const makeCoStreamerAViewer = createAction(
  makeCoStreamerAViewerActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const makeCoStreamerAViewerSuccess = createAction(
  makeCoStreamerAViewerActionTypes.success,
  (payload) => ({ payload }),
);

export const makeCoStreamerAViewerFailure = createAction(
  makeCoStreamerAViewerActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);
